import axios from 'axios'
import Vue from 'vue'
import router from '../router'

// xiongzong-laoding
import { Message, Loading } from 'element-ui';
let loading //定义loading变量

function startLoading() { //使用Element loading-start 方法
    loading = Loading.service({
        lock: true,
        spinner: 'loading',
        text: 'Loading...',
        background: 'rgba(0, 0, 0, 0.5)'
    })
}

function endLoading() { //使用Element loading-close 方法
    loading.close()
}
let needLoadingRequestCount = 0
export function showFullScreenLoading() {
    if (needLoadingRequestCount === 0) {
        startLoading()
    }
    needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
    if (needLoadingRequestCount <= 0) return
    needLoadingRequestCount--
    if (needLoadingRequestCount === 0) {
        endLoading()
    }
}
// xiongzong-laoding



const getToken = sessionStorage.getItem("token")

axios.defaults.withCredentials = true;
// axios.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';

// 创建axios实例
const service = axios.create({
        //baseURL: process.env.BASE_API, // api的base_url
        baseURL: process.env.BASE_API,
        timeout: 30000, // 请求超时时间,

        withCredentials: true, //允许携带cookie
        changeOrigin:  true
    })
    // request拦截器
service.interceptors.request.use(config => {
    if (getToken) {
        config.headers['token'] = getToken // 让每个请求携带自定义token 请根据实际情况自行修改 
    }
    showFullScreenLoading();
    return config
}, error => {
    // Do something with request error  
    Promise.reject(error)
})
var once = true;
// respone拦截器
service.interceptors.response.use(response => {
    //当返回信息为未登录或者登录失效的时候重定向为登录页面
    //     if(response.data.code == 'W_100004' || response.data.message == '用户未登录或登录超时，请登录！'){
    //     router.push({
    //         path:"/",
    //         querry:{redirect:router.currentRoute.fullPath}//从哪个页面跳转
    //     })
    // }
    if (response.data.status == '444' || response.data.message == '您已经在其他地方登录，请重新登录！') {
        if (once == true) {
            Message({
                message: response.data.message,
                type: 'error',
                duration: 5 * 1000
            })
            sessionStorage.clear();
            setTimeout(function() {
                router.push({ path: '/' });
            }, 2000);
            once = false;
        }
    } else if (response.data.status == '401' || response.data.msg == '权限不足') {
        setTimeout(function() {
            router.push({ path: '/tipspage' });
        }, 2000);
    }
    tryHideFullScreenLoading()
    return response;
}, error => {
    Message({
        message: error.message,
        type: 'error',
        duration: 5 * 1000
    })
    return Promise.reject(error)
})
export default service


// WEBPACK FOOTER //
// ./src/utils/request.js